import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const EcofriendlyGiftsforclientsandevents =()=>{
    const CTAContent = [
        {
          pageName: "Eco-Friendly Gifts for Clients and Events",
          paragraphitalic: "Eco-Chic and Event-Ready",
          paragraphText:
                "Stand out in your next event or client meeting with eco-friendly gifts that reflect your brand’s green commitment. From corporate events to client appreciation gifts, our environmentally conscious options make sure your impact is both memorable and responsible.",
          ContactFormName: "Eco-Friendly Gifts for Clients and Events",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Upcycled Bags & Apparel",
          parapgraphItalic: "Fashion with a Purpose: Upcycled Bags & Apparel!",
          sectionparagraphText: (
            <>
              <p>
                Stylish, functional, and planet-friendly – carry the change you want to see. 
                </p>
                <p>
                Step into the world of sustainable fashion with our collection of upcycled bags and apparel. Made from repurposed materials, these items combine creativity and responsibility. Perfect for everyday use or as thoughtful gifts, our upcycled products transform waste into wearable art while making a positive environmental impact. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Clients and Events/Upcycled Bags & Apparel.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Natural and Organic Hampers",
          parapgraphItalic: "Celebrate the Goodness of Nature! ",
          sectionparagraphText: (
            <>
              <p>
              Curated organic hampers that are perfect for gifting and guilt-free indulgence. 
                </p>
                <p>
                Delight your loved ones with hampers filled with natural and organic products. From artisanal teas to handmade soaps and gourmet treats, our hampers are a testament to the beauty of sustainability. Perfect for every occasion, these thoughtfully curated sets show that caring for the planet can be as enjoyable as it is rewarding. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Clients and Events/Natural and Organic Hampers.png",
          categoryHeadingLeftSide: "Features That Stand Out",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Organic Goodies.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Organic Goodies</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Eco-Friendly Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Eco-Friendly Packaging</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Customizable Options-.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Customizable Options</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Clients and Events/Features That Turn Heads.jpg",
          NogapHeading: "Features That Turn Heads",
          Heading: [
            {
              ListHeading: "Unique Designs",
              ListParagraph:
                "Each product tells its own story with one-of-a-kind patterns and textures.",
            },
            {
              ListHeading: "Durable and Versatile",
              ListParagraph:
                "Strong enough for daily use, stylish enough for any occasion.",
            },
            {
              ListHeading: "Eco-Friendly Materials",
              ListParagraph:
                "Crafted from repurposed fabric, leather, and other upcycled materials.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Clients and Events/Custom Reusable Drinkware.jpg",
          NogapHeading: "Custom Reusable Drinkware",
          paragraphItalic: "Sip Sustainably with Custom Reusable Drinkware!",
          paragraphDetail: (
            <>
              <p>
              Eco-friendly bottles, cups, and tumblers designed to reduce waste in style. 
                </p>
                <p>
                Stay hydrated while staying eco-conscious with our range of reusable drinkware. From bamboo tumblers to stainless steel bottles, our drinkware is designed for sustainability and personalization. Whether you’re looking to reduce single-use plastic or seeking unique gifts, this collection helps you make a lasting impression. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Quench Your Thirst for Sustainability",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Premium Materials.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Premium Materials</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Custom Engravings.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Engravings</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Clients and Events/Durable and Functional.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Durable and Functional</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>eYantra Eco & Employee Gifting Solutions</title>
        <meta name="description" content="eYantra delivers eco-friendly gifts, bulk gifting, branded merchandise, joining kits, and welcome kits tailored for employee and corporate gifting needs."/>
        <meta name="keywords" content="eyantra,  eco friendly gifts,  branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,bulk gifting, employee gifts"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Vest your employees with gifts that reflect shared values and contribute to a healthier planet. 
      </p>
    </>
  );
};

export default EcofriendlyGiftsforclientsandevents;